var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useRef, useCallback, useMemo } from 'react';
export function useIntersectionObserver(callback, options, deps) {
    if (options === void 0) { options = {}; }
    if (deps === void 0) { deps = []; }
    var observerRef = useRef(null);
    var callbackRef = useRef(callback);
    callbackRef.current = callback;
    var root = options.root, rootMargin = options.rootMargin, threshold = options.threshold, triggerOnce = options.triggerOnce;
    var handleRef = useCallback(function (ref) {
        var _a;
        (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        if (ref !== null) {
            var handleIntersection = function (entries, observer) {
                callbackRef.current(entries, observer);
                if (options.triggerOnce) {
                    observer.disconnect();
                }
            };
            observerRef.current = new IntersectionObserver(handleIntersection, { root: root, rootMargin: rootMargin, threshold: threshold });
            observerRef.current.observe(ref);
        }
        else {
            observerRef.current = null;
        }
    }, __spreadArray([root, rootMargin, threshold, triggerOnce], __read(deps), false));
    return useMemo(function () { return [handleRef]; }, [handleRef]);
}
//# sourceMappingURL=use-intersection-observer.js.map